<template>
  <div>
    <div class="ly-card">
      <el-radio-group v-model="type" @change="change">
        <el-radio-button :label="1">帖子举报</el-radio-button>
        <el-radio-button :label="2">回帖举报</el-radio-button>
      </el-radio-group>
    </div>
    <component :is="currentTabComponent[type - 1]"></component>
  </div>
</template>
<script>
import { RadioGroup, RadioButton } from 'element-ui';
import PostsBack from './back';
import CommPosts from './post';

export default {
  name: 'PostsIndex',
  components: { ElRadioButton: RadioButton, ElRadioGroup: RadioGroup },
  data() {
    return {
      type: 1,
      currentTabComponent: [CommPosts, PostsBack]
    };
  },
  methods: {
    change(value) {
      this.type = value;
    }
  }
};
</script>
